import RouterLogicHandler from './RouterLogicHandler.vue'

function getRouteDefs () {
  const routeDefs = [
    { path: 'ci', alias: ['barrys'], props: { sessionContext: { appId: 10 } } },
    {
      path: 'is',
      alias: ['instructor-scheduling'],
      props: { sessionContext: { appId: 17 } },
      children: [
        {
          path: 'substitution-requests/:id',
          props: route => ({
            modeParams: {
              component: () => import('src/apps/17InstructorScheduling/domains/instructorSubstitutionRequests/components/SubstitutionRequest.vue'),
              componentProps: { id: Number(route.params.id) }
            }
          })
        },
        {
          path: 'monthly-calendar/:month',
          props: route => ({
            modeParams: {
              component: () => import('src/apps/17InstructorScheduling/pages/InstructorCalendar.vue'),
              componentProps: { month: route.params.month }
            }
          })
        }
      ]
    }
  ]

  const converter = def => {
    if (!def) return null
    const res = { path: def.path, alias: def.alias, component: RouterLogicHandler, props: def.props }
    if (def.children) res.children = def.children.map(child => converter(child))
    return res
  }

  return routeDefs.map(def => converter(def))
}

const routes = [
  {
    path: '/',
    name: '',
    component: () => import('src/platform/layouts/root.vue'),
    children: [
      ...getRouteDefs()
    ]
  },

  {
    path: '/account',
    component: () => import('src/platform/layouts/Account.vue'),
    children: [
      { path: '', component: () => import('src/platform/pages/Account.vue') }
    ]
  },
  {
    path: '/login',
    component: () => import('src/platform/layouts/MyLayout2.vue'),
    children: [
      { path: '', component: () => import('src/platform/pages/Login.vue') }
    ]
  },
  {
    path: '/public(-|_)action',
    component: () => import(/* webpackChunkName: 'public_action' */ 'src/platform/pages/PublicAction.vue')
  },
  {
    path: '/pa/:id',
    component: () => import(/* webpackChunkName: 'pa' */ 'src/platform/pages/PublicAction.vue'),
    props: { short: true }
  }
]

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('src/platform/pages/Error404.vue')
  })
}

export default routes
